import request from '@/utils/request'

// 用户登录
export function login(data) {
  return request({
    url: '/admin/v1/login',
    method: 'post',
    data
  })
}

// 获取用户信息
export function getUserInfo() {
  return request({
    url: '/admin/v1/user/info',
    method: 'get'
  })
}

// 获取用户列表
export function getUserList(params) {
  return request({
    url: '/admin/v1/user/list',
    method: 'get',
    params: {
      page: params.page || 1,
      per_page: params.per_page || 10,
      keyword: params.keyword || '',
      status: params.status || '',
      ...params
    }
  })
}

// 创建用户
export function createUser(data) {
  return request({
    url: '/admin/v1/user/create',
    method: 'post',
    data
  })
}

// 更新用户
export function updateUser( data) {
  return request({
    url: `/admin/v1/user/update`,
    method: 'post',
    data
  })
}


// 修改密码
export function updatePassword(data) {
  return request({
    url: `/admin/v1/user/resetPassword`,
    method: 'post',
    data
  })
} 



